// Ramp-style animated "how it works" explainers. Pure React + CSS/SVG, no animation libraries.
// Contract (do not change signatures; variants import these):
//   tone: 'light' (on paper) | 'dark' (on indigo). autoPlay: start when scrolled into view (default true;
//   false renders the meaningful end frame statically). className: applied to the outer element.
// Each explainer is fluid (fills its container width, 4:3 stage) and works from 320px to 640px wide.
// They pause off-screen and when the tab is hidden, and show their end frame under prefers-reduced-motion.
import type { ExplainerProps } from './engine';
import { Explainer } from './engine';
import { tagDef } from './Tag';
import { handoverDef } from './Handover';
import { ownerScanDef } from './OwnerScan';
import { transferDef } from './Transfer';
import { erpSyncDef } from './ErpSync';
import { claimDef } from './Claim';
import { formsDef } from './Forms';
import { partsDef } from './Parts';
export type { ExplainerProps } from './engine';
export type { ExplainerUnit, PartnerRole } from './unit';
export { DEFAULT_UNIT, AGRI_UNIT } from './unit';
export { HowItWorksSequence } from './Sequence';

/** 1. ERP → codes: a packing slip row from the ERP prints as a label on the serial plate. */
export const TagExplainer = (p: ExplainerProps) => <Explainer def={tagDef} {...p} />;
/** 2. Dealer handover: phone PDI checklist ticked, signature, "Warranty active from today". */
export const HandoverExplainer = (p: ExplainerProps) => <Explainer def={handoverDef} {...p} />;
/** 3. Owner scan: viewfinder → unit page (manual for build, parts, book service, ask) → cited answer. */
export const OwnerScanExplainer = (p: ExplainerProps) => <Explainer def={ownerScanDef} {...p} />;
/** 4. Ownership transfer: record card moves from owner 1 to owner 2 with consent, history intact. */
export const TransferExplainer = (p: ExplainerProps) => <Explainer def={transferDef} {...p} />;
/** 5. ERP sync: two-way lanes between your ERP and BrandedMark. */
export const ErpSyncExplainer = (p: ExplainerProps) => <Explainer def={erpSyncDef} {...p} />;
/** 6. Claim arrives complete: case card assembles serial, owner, dealer, photos, history, warranty. */
export const ClaimExplainer = (p: ExplainerProps) => <Explainer def={claimDef} {...p} />;
/** 7. Forms: a scanned PDF becomes a structured form (a person publishes it), signed by installer and owner, sealed on the unit. */
export const FormsExplainer = (p: ExplainerProps) => <Explainer def={formsDef} {...p} />;
/** 8. Parts: the unit explains a fault, offers the part that fits, checkout, routed to the installer and ERP; consumable reorder. */
export const PartsExplainer = (p: ExplainerProps) => <Explainer def={partsDef} {...p} />;
